import { EmailOtpRepository, FindTotpSecretResponse } from '@contexts/auth/domain';
import { isNil } from '@contexts/shared/domain';
import { users } from '@contexts/users/infrastructure';

type TemporalToken = {
	token: string;
	userId: string;
};

export const temporalTokens: TemporalToken[] = [
	{
		token: 'token',
		userId: users[0].id
	}
];

export function inMemoryEmailOtpRepositoryBuilder(): EmailOtpRepository {
	return {
		generateSecret: async (token: string): Promise<void> => {
			const temporalToken = temporalTokens.find(
				(temporalToken) => temporalToken.token === token
			);

			if (isNil(temporalToken)) {
				throw new Error('Temporal token not found');
			}
		},
		verifyCode: async (token: string, code: string): Promise<void> => {
			const temporalToken = temporalTokens.find(
				(temporalToken) => temporalToken.token === token
			);

			if (isNil(temporalToken)) {
				throw new Error('Temporal token not found');
			}

			if (code !== '123456') {
				throw new Error('Invalid 2FA code');
			}

			return Promise.resolve();
		}
	};
}
